<template>
  <div>
    <h3 class="error-title">
      Oops, something went wrong
    </h3>
    <p>
      Please contact us at {{ settings.company_phone }} or
      <a :href="`mailto:${settings.company_email}`">{{ settings.company_email }}</a>
      to resolve the issue and continue with your application.
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Error",
  computed: {
    ...mapState("settings", ["settings"]),
  }
};
</script>

<style scoped>

</style>
